/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 领取优惠券
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  couponCode: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/coupon/${couponCode}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
